/* eslint-disable @next/next/no-img-element */
import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'

function Svg({ src, color, className }) {
    if (src.includes('/api/storage')) {
        return (
            <span
                className={className}
                css={css`
                    display: inline-block;
                    & svg {
                        width: 100%;
                        height: 100%;
                    }
                `}
            >
                <img alt="" src={src} />
            </span>
        )
    } else {
        if (color) {
            const match = src.match(/fill="\w{18}"/)
            if (match) {
                src = src.replace(new RegExp(match[0]), '')
            }
            src = src.replace(/<svg/, `<svg fill="${color}"`)
        }
        return (
            <span
                className={className}
                css={css`
                    display: inline-block;
                    & svg {
                        width: 100%;
                        height: 100%;
                    }
                `}
                dangerouslySetInnerHTML={{ __html: src }}
            >
                {/* <img src={src} /> */}
            </span>
        )
    }
}

Svg.propTypes = {
    src: PropTypes.string.isRequired,
    color: PropTypes.string
}

export default Svg
